import React from 'react';
import { Flame, DollarSign } from 'lucide-react';

/**
 * Rating 0-5 cliccabile. `variant="fuochi"` per i Contatti, `variant="dollari"` per i Clienti.
 * Se `onChange` non e' passato, il rating e' solo visualizzato (read-only).
 */
const RatingPicker = ({ value = 0, onChange, variant = 'fuochi', size = 16, className = '' }) => {
  const isDollari = variant === 'dollari';
  const Icon = isDollari ? DollarSign : Flame;
  const activeColor = isDollari ? 'text-lime-600' : 'text-orange-500';
  const readOnly = typeof onChange !== 'function';

  return (
    <div className={`flex items-center gap-0.5 ${className}`} role={readOnly ? undefined : 'radiogroup'}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onClick={(e) => {
            e.stopPropagation();
            if (!readOnly) onChange(value === n ? 0 : n);
          }}
          className={`${readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110'} transition-transform p-0.5 -m-0.5`}
          aria-label={`${n}`}
        >
          <Icon
            width={size}
            height={size}
            className={n <= value ? activeColor : 'text-zinc-200'}
            fill={!isDollari && n <= value ? 'currentColor' : 'none'}
            strokeWidth={isDollari ? 2 : (n <= value ? 0 : 1.5)}
          />
        </button>
      ))}
    </div>
  );
};

export default RatingPicker;
